// extracted by mini-css-extract-plugin
module.exports = {"policyContainer":"rate_plan_policies_policyContainer__OOXta","policyCell":"rate_plan_policies_policyCell__22MMS","mealContainer":"rate_plan_policies_mealContainer__3dhEV"};